// Engine API: bond delegations.
// Backed by ~/Dev/seitiate/app/api/v1/bond_delegations.py.

import { engineFetchJson } from '@/lib/engineHttp';
import type {
  BondDelegationListResponse,
  BondDelegationRead,
  CreateDelegationBody,
  DelegationStatus,
  RevokeDelegationBody,
} from './agentBoardTypes';

export interface ListBondDelegationsParams {
  /** Required for non-Director callers. Director may omit for full tenant view. */
  owner_id?: string;
  status?: DelegationStatus;
  limit?: number;
}

/** GET /api/v1/bond-delegations. Shipped in seitiate#35 (merged 2026-05-04). */
export async function listBondDelegations(
  params: ListBondDelegationsParams = {},
): Promise<BondDelegationListResponse> {
  const qs = new URLSearchParams();
  if (params.owner_id) qs.set('owner_id', params.owner_id);
  if (params.status) qs.set('status', params.status);
  if (typeof params.limit === 'number') qs.set('limit', String(params.limit));
  const suffix = qs.toString();
  return engineFetchJson<BondDelegationListResponse>(
    `/bond-delegations${suffix ? `?${suffix}` : ''}`,
  );
}

export async function createBondDelegation(
  body: CreateDelegationBody,
): Promise<BondDelegationRead> {
  return engineFetchJson<BondDelegationRead>('/bond-delegations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function getBondDelegation(
  id: string,
): Promise<BondDelegationRead> {
  return engineFetchJson<BondDelegationRead>(
    `/bond-delegations/${encodeURIComponent(id)}`,
  );
}

export async function revokeBondDelegation(
  id: string,
  body: RevokeDelegationBody,
): Promise<BondDelegationRead> {
  return engineFetchJson<BondDelegationRead>(
    `/bond-delegations/${encodeURIComponent(id)}/revoke`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
